/* 설비 상태 코드(백엔드 equipment.status) → 화면 한글 키 · 배지 색. 설비 목록과 설비 상세가 같이 쓴다. */
export const EQUIPMENT_STATUS_KO = {
  RUNNING: '가동',
  IDLE: '대기',
  STOPPED: '정지',
  MAINTENANCE: '점검',
  FAULT: '고장',
  OFFLINE: '오프라인'
};

/* management.css 의 .mg-badge 색 이름 */
export const EQUIPMENT_STATUS_BADGE = {
  '가동': 'success',
  '대기': 'warning',
  '정지': 'neutral',
  '점검': 'info',
  '고장': 'error',
  '오프라인': 'neutral'
};
